import config from '../../config';
import { request } from '../../libraries/request'

const getAll = (params = {}, token) => {
  console.log('SERVICES::CATEGORIES::get', params, token);
  if (params && params.page_num && config.QUERIES_PAGE_SIZE) {
    params.page_size = config.QUERIES_PAGE_SIZE;
  }
  if (!params.order_by) { 
    params.order_by = 'name';
    params.order_direction = 'ASC';
  }
  params.enabled = 1;

  return request({
    url: config.BASE_API_URL + config.API.CATEGORIES,
    accessToken: token,
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  })
}

const save = (params, token) => {
  console.log('SERVICES::CATEGORIES::save', params, token);
  return request({
    url: config.BASE_API_URL + config.API.CATEGORIES,
    accessToken: token,
    method: 'POST',
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const update = (params, token) => {
  console.log('SERVICES::CATEGORIES::update', params, token);
  return request({
    url: config.BASE_API_URL + config.API.CATEGORY.replace('{id}', params.id),
    accessToken: token,
    method: 'PATCH',
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const get = (params, token) => {
  console.log('CATEGORIES::CATEGORIES::get', params.id, token);
  return request({
    url: config.BASE_API_URL + config.API.CATEGORY.replace('{id}', params.id),
    accessToken: token,
    // data: {},
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })

}

const del = (params, token) => {
  console.log('SERVICES::CATEGORIES::remove', params.id, token);
  return request({
    url: config.BASE_API_URL + config.API.CATEGORY.replace('{id}', params.id),
    accessToken: token,
    method: 'DELETE',
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const getPath = (params = {}, token) => {
  console.log('SERVICES::CATEGORIES::getPath', params, token);
  if (params && params.page_num && config.QUERIES_PAGE_SIZE) {
    params.page_size = config.QUERIES_PAGE_SIZE;
  }
  if (!params.order_by) { 
    params.order_by = 'order_index';
    params.order_direction = 'DESC';
  }

  console.log('PARAMS', params);
  return request({
    url: config.BASE_API_URL + config.API.CATEGORY_PATH.replace('{id}', params.id),
    accessToken: token,
    data: params,    
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  })
}

export default {
  getAll,
  save,
  get,
  del,
  update,
  getPath,
};